/* global axios */
import ApiClient from './ApiClient';

class ConversationNotesAPI extends ApiClient {
  constructor() {
    super('conversations', {
      accountScoped: true,
    });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/notes`;
  }

  get(conversationId) {
    return axios.get(this.getUrl(conversationId));
  }

  show(conversationId, noteId) {
    return axios.get(`${this.getUrl(conversationId)}/${noteId}`);
  }

  create(conversationId, noteData) {
    return axios.post(this.getUrl(conversationId), {
      note: noteData,
    });
  }

  update(conversationId, noteId, noteData) {
    return axios.patch(`${this.getUrl(conversationId)}/${noteId}`, {
      note: noteData,
    });
  }

  delete(conversationId, noteId) {
    return axios.delete(`${this.getUrl(conversationId)}/${noteId}`);
  }
}

export default new ConversationNotesAPI();
